import React from 'react';
import { Col, Container, Row } from "react-bootstrap";

const Partner = () => {
    return (
        <div className="partner-usa p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="partner_content">
                            <h2>Ensure Business Credibility with the Most Reliable Intellectual Property Protection</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>At TekRevol, we are dedicated to delivering top-notch intellectual property protection services. With a track record of serving numerous businesses globally, we have established a renowned reputation in the industry for our ideal support. That’s why we have become the preferred choice for organizations at various levels seeking comprehensive IP protection services.</p>
                    </Col>
                </Row>
                <Row className="h-100 partner_padd">
                    <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                        <div className="partner-num">
                        4.8
                        </div>
                        <div className="partner-para">
                            <p>Average Clutch Rating</p>
                        </div>
                    </Col>
                    <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                        <div className="partner-num">
                        10th
                        </div>
                        <div className="partner-para">
                            <p>Ranked on RightFirms</p>
                        </div>
                    </Col>
                    <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
                        <div className="partner-num">
                        4.4
                        </div>
                        <div className="partner-para">
                            <p>Average Google Play Rating</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Partner